import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { CMS_LANGUAGE_IDS } from 'umg-ember-backend/utils/cms-languages';
import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  cmsLanguageId: validator('inclusion', { in: CMS_LANGUAGE_IDS }),
});

export const settings = {
  saveHooks: {
    after: [saveHasManyRelationships('workContributors')],
  },
};

export default class ProductWorkModel extends Model.extend(Validations) {
  @attr('string') name;
  @attr('number') level;
  @attr('number') mmcId;

  // CMS fields
  @attr('string', { defaultValue: '1' }) cmsLanguageId;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relation
  @hasMany('product-work-contributor', { async: true, inverse: 'productWork' })
  workContributors;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return `${this.name} (${this.id})`;
  }
}
